import { render } from "./InputError.vue?vue&type=template&id=42f5bf94"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__